import axios from "axios"

export const api = axios.create({
  baseURL: "https://api.virtual.brasilbeneficios.club/api",
})

export const qarApi = axios.create({
  baseURL: "https://qar.brasilbeneficios.club/api",
})
